import { Component } from '@angular/core';

import { ConfirmModalService } from './confirm.modal.service';
import { AppService } from '../../../app.service';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import translateJson from "../../../../translate.json";


@Component({
    selector: 'confirm-modal-comp',
    providers: [AppService, NgxSmartModalService],
    templateUrl: './confirm.modal.component.html',
    styleUrls: ['./confirm.modal.component.css']
})

export class ConfirmModalComponent {

    // Get translation/text from translation.json
    private i18 = translateJson.i18;

    private defaults = {
        title: this.i18.modals.confirmModal.title,
        message: this.i18.modals.confirmModal.messageContinue,
        messageArray: [this.i18.modals.confirmModal.messageContinue],
        showConfimButton: true,
        cancelButtonText: this.i18.modals.confirmModal.cancelButton,
        showCancelButton: true,
        confirmButtonText: this.i18.modals.confirmModal.okButton,
        type: 'warning'
    };

    title: String;
    messageArray: String[];
    showConfimButton: boolean;
    confirmButtonText: String;
    showCancelButton: boolean;
    cancelButtonText: String;
    type: String;
    message: String;

    // the return object that the modal listens to for changes
    modalAnswer = {
        answerInternal: null,
        answerListener: function(value) {},
        set answer(value) {
          this.answerInternal = value;
          this.answerListener(value);
        },
        get answer() {
          return this.answerInternal;
        },
        registerAnswerListener: function(listener) {
          this.answerListener = listener;
        }
    }
    
    constructor(
        private confirmModalService: ConfirmModalService,
        private ngxSmartModalService: NgxSmartModalService
    ){
        confirmModalService.pop = this.pop.bind(this);
    }

    /**
     * If confirm button pressed set return value to true and close the modal
     */
    public onConfirm(): void {
        this.modalAnswer.answer = true;
        this.ngxSmartModalService.get('configurableConfirmModal').close();
    }

    /**
     * If cancel button pressed set return value to false and close the modal
     */
    public onCancel(): void {
        this.modalAnswer.answer = false;
        this.ngxSmartModalService.get('configurableConfirmModal').close();
    }

    /**
     * Pop the modal and display it's contents
     * @param message 
     * @param title 
     * @param confirmButtonText 
     * @param cancelButtonText 
     * @returns true/false promise
     */
    public pop(message:string[] = this.defaults.messageArray, 
        title:string = this.defaults.title,
        showConfimButton: boolean = this.defaults.showConfimButton,
        confirmButtonText:string = this.defaults.confirmButtonText,
        showCancelButton: boolean = this.defaults.showConfimButton, 
        cancelButtonText:string = this.defaults.cancelButtonText,
        type: String = this.defaults.type){

            this.messageArray = message;
            this.title = title;
            this.showCancelButton = showCancelButton;
            this.cancelButtonText = cancelButtonText;
            this.showConfimButton = showConfimButton;
            this.confirmButtonText = confirmButtonText;
            this.type = type;
            this.ngxSmartModalService.getModal('configurableConfirmModal').open();
            
            let promise = new Promise<boolean>(resolve => {
                this.show(resolve);
            });
            
            return promise
    }

    /**
     * Register the modal button listener to wait for action and return a value to the promise
     * @param resolve boolean
     */
    private show(resolve:(boolean) => any) {
        this.modalAnswer.registerAnswerListener(function(value) {
            resolve(value);
        });
    }

}